export default "__VITE_ASSET__65681a5d__"